const state = {
  lastLesson: {}, //上次学到（未听完的回放课or录播课）
};
const mutations = {
  setLastLesson: (state, data) => {
    let { user_id, course_id, unit_id, lesson_id } = data;
    if (state.lastLesson[user_id]) {
      // 存在
    } else {
      state.lastLesson[user_id] = {};
    }
    state.lastLesson[user_id][course_id] = { unit_id, lesson_id };
  },
  delLastLesson: (state, data) => {
    console.log(
      data,
      "===LastLesson======delLastLesson",
      JSON.parse(JSON.stringify(state.lastLesson))
    );

    let { user_id, course_id, lesson_id } = data;
    if (state.lastLesson?.[user_id]?.[course_id]?.lesson_id === lesson_id) {
      // 存在
      delete state.lastLesson[user_id][course_id];
      console.log(
        JSON.parse(JSON.stringify(state.lastLesson)),
        "===LastLesson======delLastLesson===delete"
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
